module.exports = "<div class=\"kan-services-list\">\n    <kan-service-list-item *ngFor=\"let service of services\"\n                           [service]=\"service\"\n                           (refresh)=\"emitRefresh()\">\n    </kan-service-list-item>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/components/service/list/component.html
// module id = ./src/modules/admin/components/service/list/component.html
// module chunks = main